var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddIconBig(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.9996 26.9999H33.0001V2.99981C33.0001 1.34417 31.6559 0 29.9997 0C28.3441 0 26.9999 1.34417 26.9999 2.99981V26.9999H2.99981C1.34417 26.9999 0 28.3441 0 29.9997C0 31.6559 1.34417 33.0001 2.99981 33.0001H26.9999V56.9996C26.9999 58.6558 28.3441 60 29.9997 60C31.6559 60 33.0001 58.6558 33.0001 56.9996V33.0001H56.9996C58.6558 33.0001 60 31.6559 60 29.9997C60 28.3441 58.6558 26.9999 56.9996 26.9999V26.9999Z",
    fill: "#FB607F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddIconBig);
export default __webpack_public_path__ + "static/media/add-icon-big.6593d9d601dd062cbc7a5c437580cee8.svg";
export { ForwardRef as ReactComponent };